/*
 *		Copyright (c) 2011-2014 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

angular.module('access.Nodes')
    .controller('RevisionsController', [
        '$scope', '$modalInstance', 'element', 'operationComplete', 'template', 'NodeRevision', 'purgeSelectedRevisions', 'Settings',
        function ($scope, $modalInstance, element, operationComplete, template, NodeRevision, purgeSelectedRevisions, Settings) {
            $scope.modal = $modalInstance.options;
            $scope.modal.footerTemplate = template('nodes/_revisions_modal_footer');
            $scope.node = element;
            $scope.deleteMode = false;

            NodeRevision.query({node_uuid: $scope.node.uuid}).$promise.then(function (revisions) {
                $scope.node.revisions = revisions.map(function (revision) {
                    return Object.defineProperties(revision, {
                        canBeDownloaded: {
                            get: function () {
                                return this.available && $scope.node.canBeDownloaded();
                            }
                        },
                        canBeRestored: {
                            get: function () {
                                return this.available && !this.is_latest && !$scope.node.read_only;
                            }
                        },
                        canViewNotarizationCertificate: {
                            get: function () {
                                return Settings.cloud_platform_notarization_enabled && this.notarization && this.notarization.status === 'successful';
                            }
                        }
                    });
                });
            });

            $scope.showActionsColumn = function () {
                if ($scope.node['is_directory']) return false;
                if ($scope.deleteMode) return false;

                return true;
            };

            $scope.toggleHighlightedRevision = function (revision, isActionsMenuOpen) {
                if (isActionsMenuOpen) {
                    $scope.highlightedRevision = revision;
                } else {
                    // unset the highlighted revision only if another one has not been selected
                    if ($scope.highlightedRevision === revision) {
                        $scope.highlightedRevision = null;
                    }
                }
            };

            $scope.restore = function (selectedRevision) {
                selectedRevision.$restore(function (restoredRevision) {
                    operationComplete('file_operation_restore_from_revision_success_message', {
                        file_name: restoredRevision['name'],
                        revision: selectedRevision['revision']
                    });

                    $modalInstance.close('reload_nodes');
                });
            };

            $scope.toggleDeleteMode = function () {
                $scope.deleteMode = !$scope.deleteMode;

                if ($scope.deleteMode) {
                    _unselectAll();
                }
            };

            $scope.canDelete = function () {
                return $scope.deleteMode && _selectedRevisions().length > 0;
            };

            $scope.delete = function () {
                var
                    items = _selectedRevisions().map(function (revision) {
                        return Object.defineProperties({
                            uuid: revision.node_uuid,
                            revision: revision.revision
                        }, {
                            // In order to be compatible with signed_notarized_files_delete_warning
                            // we need to implement 2 methods,
                            // which makes our revision looks like a node
                            latest_notarized_revision: {
                                get: function () {
                                    return revision.notarization && revision.notarization.status === 'successful' ? {notarization: revision.notarization} : null;
                                }
                            },
                            has_esignature: {
                                value: revision.has_esignature
                            }
                        });
                    });

                $scope.modal.loading = true;

                purgeSelectedRevisions(items).then(function () {
                    operationComplete('revisions_permanently_deleted_message', { COUNT: items.length, filename: $scope.node.name }, 'messageformat');

                    $modalInstance.close('reload_nodes');
                }).finally(function () {
                    $scope.modal.loading = false;
                });
            };

            $scope.areAllSelected = function () {
                return _selectedRevisions().length === _selectableRevisions().length;
            };

            $scope.toggleSelectAll = function () {
                var state = $scope.areAllSelected();

                angular.forEach(_selectableRevisions(), function (revision) {
                    revision['selected'] = !state;
                });
            };

            $scope.close = $scope.cancel = function () {
                $modalInstance.dismiss('cancel');
            };

            function _unselectAll() {
                _iterateRevisions(function (revision) {
                    revision['selected'] = false;
                });
            }

            function _selectedRevisions() {
                return $scope.node.revisions.filter(function (revision) {
                    return revision['selected'];
                });
            }

            function _selectableRevisions() {
                return $scope.node.revisions.filter(function (revision) {
                    return revision['available'] && !revision['is_latest'];
                });
            }

            function _iterateRevisions(fn) {
                $scope.node.revisions.forEach(fn);
            }
        }]);
